import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../theme/tokens';

export const FormGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '14px',
  gridTemplateColumns: 'repeat(5, 1fr) auto',
  alignItems: 'end',
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr',
  },
}));

export const Field = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
}));

export const FieldLabel = styled(Typography)(() => ({
  fontSize: '11px',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.03em',
  color: protoColors.textMuted,
}));

const controlStyle = {
  fontFamily: 'inherit',
  fontSize: '13px',
  color: protoColors.textPrimary,
  padding: '9px 12px',
  borderRadius: '10px',
  border: `1px solid ${protoColors.border}`,
  backgroundColor: protoColors.surface,
  width: '100%',
};

export const Select = styled('select')(() => ({
  ...controlStyle,
  cursor: 'pointer',
}));

export const Input = styled('input')(() => ({
  ...controlStyle,
  '&:focus': {
    outline: 'none',
    borderColor: protoColors.purple,
  },
}));

export const AddButton = styled('button')(() => ({
  border: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: '14px',
  fontWeight: 700,
  color: protoColors.surface,
  backgroundColor: protoColors.purple,
  borderRadius: '10px',
  padding: '10px 20px',
  height: '38px',
  '&:hover': {
    backgroundColor: protoColors.purpleDark,
  },
}));

export const RemoveButton = styled('button')(() => ({
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  fontFamily: 'inherit',
  fontSize: '13px',
  fontWeight: 600,
  color: protoColors.danger,
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const Spacer = styled(Box)(() => ({
  marginTop: '24px',
}));
